import clsx from 'clsx';
import { useState } from 'react';
import PrimaryButton from '../../button/PrimaryButton';
import askPikko from '../../../styles/img/logo/ask-pikko.svg';
import useAxios from '../../../axios/useAxios';

const JackpotContentRenderer = ({ orderId, jackpot }) => {
  const axiosInstance = useAxios();
  const [isLoadingJackpotUnavailableModal, setIsLoadingJackpotUnavailableModal] = useState(false);

  async function handleCloseJackpotUnavailableModal () {
    setIsLoadingJackpotUnavailableModal(true);

    try {
      await axiosInstance.put(`/orders/${orderId}/jackpot`, {
        ...jackpot,
        isAvailable: false
      });
    } catch (error) {
      console.error("handleCloseJackpotUnavailableModal", error);
    } finally {
      setTimeout(() => {
        window.location.reload();
        setIsLoadingJackpotUnavailableModal(false);
      }, 250);
    }
  }

  return (
    <>
      <h1 className="text-3xl text-center my-6 text-black">
        Cagnotte indisponible.
      </h1>

      <p className="text-2xl text-gray-500 text-center mb-6 geomanistRegular">
        Tu vas devoir choisir une autre méthode de paiement.
      </p>

      <div className="text-xl text-[#117C26] text-left mb-6 geomanistRegular bg-[#C4EEB9] rounded-xl p-4">
        Tu peux avoir l’esprit tranquille, ta cagnotte est restée intacte.
      </div>

      <div className="mt-0 mb-2 flex flex-col gap-4 justify-center items-center w-full">
        <PrimaryButton
          label="D'accord"
          className="w-full mt-4"
          onClick={handleCloseJackpotUnavailableModal}
          disabled={isLoadingJackpotUnavailableModal}
          isLoading={isLoadingJackpotUnavailableModal}
        />
      </div>
    </>
  );
};

export const JackpotUnavailableModal = ({ isOpen, orderId, jackpot }) => {
  return (
    <>
      <div
        className={clsx(
          "fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[1800] transition-opacity duration-300",
          {
            "opacity-100": isOpen,
            "opacity-0 pointer-events-none": !isOpen
          }
        )}/>

      <div
        className={clsx(
          "fixed top-1/2 left-1/2 transform -translate-x-1/2 flex flex-col justify-center items-center -translate-y-1/2 bg-white rounded-2xl p-8 z-[1801] w-[90vw] transition-all duration-500",
          {
            "opacity-100 scale-100": isOpen,
            "opacity-0 scale-75 pointer-events-none": !isOpen
          }
        )}
        style={{
          transitionTimingFunction: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          maxWidth: '450px'
        }}
      >
        <div className="flex justify-center items-center">
          <img src={askPikko} alt="jackpotUnavailablePikko askPikko" className="w-28 h-28" />
        </div>

        <JackpotContentRenderer orderId={orderId} jackpot={jackpot} />
      </div>
    </>
  );
};
